import { convertObjectToOptions } from '@shared/ui';
import { EmployeeStatusEnum } from './enums';

export const STATUS_OPTIONS = convertObjectToOptions(EmployeeStatusEnum);
